<template>
  <confirmation-prompt
    id="matching-stock-car-prompt"
    :show="show"
    :title="retrieveModalText('title')"
    :info-text="retrieveModalText('infotext')"
    :extra-wide="true"
    @confirm="confirm"
    @cancel="close"
    @close="close"
  >
    <form-toggle
      id="copy-accessories"
      v-model="isCopyAccessories"
      :title="retrieveModalText('copyaccessories')"
    />

    <form-toggle
      id="copy-deliverycosts"
      v-model="isCopyDeliveryCosts"
      :title="retrieveModalText('copydeliverycosts')"
    />

    <form-toggle
      id="copy-nonrecoverablecosts"
      v-model="isCopyNonCoverableCosts"
      :title="retrieveModalText('copynonrecoverablecosts')"
    />

    <form-toggle
      id="copy-exchangecar"
      v-model="isCopyExchangeCar"
      :title="retrieveModalText('copyexchangecar')"
    />

    <form-toggle
      id="copy-discount"
      v-model="isCopyDiscount"
      :title="retrieveModalText('copydiscount')"
    />
  </confirmation-prompt>
</template>

<script>
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import FormToggle from '@/components/generic/presentational/atoms/formCheckbox/FormToggle.vue'

export default {
  components: {
    ConfirmationPrompt,
    FormToggle,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'confirm'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      labelPrefix: '/stockmatch/prompt/',
      isCopyAccessories: true,
      isCopyDeliveryCosts: true,
      isCopyExchangeCar: true,
      isCopyDiscount: true,
      isCopyNonCoverableCosts: true,
    }
  },
  mounted() {
    this.isCopyAccessories = true
    this.isCopyDeliveryCosts = true
    this.isCopyNonCoverableCosts = true
    this.isCopyExchangeCar = true
    this.isCopyDiscount = true
  },
  methods: {
    retrieveModalText(labelName) {
      return this.i18n.t(`${this.labelPrefix}${labelName}`)
    },
    close() {
      this.$emit('close')
    },
    confirm() {
      var options = {
        isCopyAccessories: this.isCopyAccessories,
        isCopyExchangeCar: this.isCopyExchangeCar,
        isCopyDeliveryCosts: this.isCopyDeliveryCosts,
        isCopyNonCoverableCosts: this.isCopyNonCoverableCosts,
        isCopyDiscount: this.isCopyDiscount,
      }
      this.$emit('confirm', options)
    },
  },
}
</script>

<style></style>
